const videoWrappers = [...document.querySelectorAll('.kjb-video-responsive')];

function waitForImageLoad(videoWrapper, img) {
  if (img.complete && img.naturalWidth !== 0) {
    applyPadding(videoWrapper, img);
    return;
  }

  img.onload = () => {
    applyPadding(videoWrapper, img);
    img.onload = null;
  };
}

function applyPadding(videoWrapper, img) {
  videoWrapper.style.paddingBottom = (100 * img.naturalHeight / img.naturalWidth) + '%';
}

function addMutationObserver(videoWrapper) {
  const observer = new MutationObserver((_mutations, obs) => {
    const img = videoWrapper.querySelector('img');
    if (img) {
      waitForImageLoad(videoWrapper, img);
      obs.disconnect();
    }
  });

  observer.observe(videoWrapper, {
    childList: true,
    subtree: true
  });
}

videoWrappers.forEach(videoWrapper => {
  const existingImg = videoWrapper.querySelector('img');
  if (existingImg) waitForImageLoad(videoWrapper, existingImg);
  else addMutationObserver(videoWrapper);
});
